import React, { useEffect, useState } from 'react'
import { isEmpty } from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Form, useFormik, FormikProvider } from 'formik'
import { FormControl, Typography } from '@material-ui/core'

import { resizeAvatar_80 } from 'commons/resizeImage'
import { SECONDARY, CLOSE } from 'app/constants/button'
import { useUserProfile } from 'commons/useUserProfile'

import Avatars from 'app/componentV4/Avatar/Avatars'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'

const CommentContainer = (props) => {
  const {
    onSubmit,
    isLoading,
    text = '',
    submitText,
    placeholder,
    isClose = true,
    isInput = true,
    isSuccess = false,
    commentStatus = 0,
    onClose = () => {},
  } = props

  const profile = useUserProfile()
  const { formatMessage } = useIntl()
  const isMockURL = profile.photoURL === 'assets/images/avatars/profile.jpg'

  const [content, setContent] = useState(text)

  const formik = useFormik({
    initialValues: {
      text: text,
    },
    enableReinitialize: isSuccess,
  })

  useEffect(() => {
    return () => {
      formik.resetForm()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    localStorage.setItem('commentFormIsDirty', formik.dirty)
  }, [formik.dirty])

  useEffect(() => {
    if (isSuccess) {
      setContent(formik.values.text)
      formik.resetForm()
      onClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess])

  useEffect(() => {
    setContent(text)
  }, [text])

  return (
    <>
      {commentStatus === 1 && !isInput && (
        <Typography className="text-primary text-14">{content}</Typography>
      )}
      {isInput ? (
        <FormikProvider value={formik}>
          <Form>
            <div className="flex items-start space-x-3">
              <Avatars
                id={profile.id}
                name={profile.displayName}
                src={isMockURL ? null : resizeAvatar_80(profile.photoURL)}
                characters={profile.avatarCharacters}
                className={'w-40 h-40 text-14 font-bold'}
              />
              <FormControl variant="outlined" className="w-full">
                <SimpleInput
                  id="comments-box"
                  name="text"
                  placeholder={placeholder}
                  multiline
                  rows={3}
                  fullWidth
                  inputProps={{ maxLength: 500 }}
                  maxLength={500}
                  value={formik.values.text}
                  onChange={(event) => {
                    formik.setFieldValue('text', event.target.value)
                  }}
                />
                <div className="flex justify-end mt-3 space-x-3">
                  {isClose ? (
                    <OutlinedButtons
                      color={CLOSE}
                      onClick={() => {
                        formik.resetForm()
                        onClose()
                      }}
                      disabled={isLoading}
                    >
                      {formatMessage({
                        id: 'text.close',
                      })}
                    </OutlinedButtons>
                  ) : null}

                  <ContainedButton
                    type="submit"
                    color={SECONDARY}
                    isLoading={isLoading}
                    disabled={
                      isEmpty(formik.values.text) || !formik.dirty || isLoading
                    }
                    onClick={async () => {
                      await onSubmit(formik.values)
                    }}
                  >
                    {submitText}
                  </ContainedButton>
                </div>
              </FormControl>
            </div>
          </Form>
        </FormikProvider>
      ) : null}
    </>
  )
}

CommentContainer.propTypes = {
  text: PropTypes.string,
  isClose: PropTypes.bool,
  isInput: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  submitText: PropTypes.string,
  placeholder: PropTypes.string,
  commentStatus: PropTypes.number,
}

export default CommentContainer
